// extracted by mini-css-extract-plugin
module.exports = {"draggableItemCard":"styles_draggableItemCard__3A93e"};